import { nodeApiClient } from 'nodeApiClient';
import { routes, ApiClientResponse } from '../../common/services';
import { ID } from '../../common/types';
import { ChatroomDataObject } from '../data-objects';

export const deleteChatroom = (chatroom: ID) =>
  nodeApiClient.delete<ChatroomDataObject, ApiClientResponse<ChatroomDataObject>>(routes.chatrooms.delete(chatroom));
